import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import {
  AnnouncementIcon,
  ArrowLeftIcon,
  BankNoteIcon,
  BarChartIcon,
  ExclamationCircleIcon,
  FlagIcon,
  FlexAlignBottomIcon,
  HomeSmileIcon,
  LayersThreeIcon,
  LayoutAltIcon,
  LogoutIcon,
  UploadIcon,
  UserCircleIcon,
} from '../../assets/icons';
import useAuthentication from '../../hooks/auth';
import IconButton from '../IconButton/IconButton';

import './Navbar.scss';

/**
 *
 * @param {{
 *   text: string,
 *   icon: SVGSVGElement,
 *   uri: string,
 *   active?: string
 * }} props
 */
function NavMenuItem({ text, icon: Icon, uri, active = '' }) {
  return (
    <Link to={uri} className={`nav-item ${active === uri ? 'active' : null}`}>
      <div className="active-indicator"></div>
      <div className="nav-item-content">
        <div className="icon">
          <Icon />
        </div>
        <span className="text">{text}</span>
      </div>
    </Link>
  );
}

function SubMenuItem({ text, uri, active = '' }) {
  return (
    <Link to={uri} className={`sub-nav-item ${active === uri ? 'active' : null}`}>
      <div></div>
      <span className="text">{text}</span>
    </Link>
  );
}

/**
 * Navbar component
 * @param {{
 *   onExpand: () => void,
 *   activePage: string,
 *   expanded: boolean,
 * }} props
 * @returns
 */
function Navbar({ onExpand, activePage, expanded }) {
  const { logout } = useAuthentication();
  const [active, setActive] = useState(null);

  useEffect(
    function () {
      setActive(activePage);
    },
    [activePage],
  );

  return (
    <>
      <div className={`navbar ${expanded ? null : 'collapsed'}`}>
        <div className="top-bx">
          <div className="top-grp">
            <div className="nav-logo">
              <Link to="/">
                <img
                  className={`logo ${expanded ? 'hide' : null}`}
                  src="/images/logo.png"
                  alt="Saroja Opticians Logo"
                />
                <img
                  className={`brand ${expanded ? null : 'hide'}`}
                  src="/images/brand-name.png"
                  alt="Saroja Opticians Brand Name"
                />
              </Link>
            </div>

            <div className={`nav-toggler ${expanded ? 'expanded' : null}`}>
              <IconButton icon={<ArrowLeftIcon />} onClick={onExpand} />
            </div>
          </div>

          <div className="nav-menu">
            <h1>MENU</h1>
            <div className="nav-menu-items">
              <NavMenuItem uri="/dashboard" text="Dashboard" icon={HomeSmileIcon} active={active} />
              <NavMenuItem uri="/prescription" text="Prescription Form" icon={LayoutAltIcon} active={active} />
              <NavMenuItem uri="/purchases" text="Purchases" icon={BankNoteIcon} active={active} />
              <NavMenuItem uri="/orders" text="Orders" icon={FlexAlignBottomIcon} active={active} />
              <NavMenuItem uri="/campaigns" text="Campaigns" icon={FlagIcon} active={active} />
              <NavMenuItem uri="/customers" text="Customers" icon={UserCircleIcon} active={active} />
              <NavMenuItem uri="/inventory" text="Inventory" icon={LayersThreeIcon} active={active} />
              <NavMenuItem uri="/suppliers" text="Supply Chain" icon={UploadIcon} active={active} />
              <div className="sub-nav-items">
                <SubMenuItem uri="/suppliers" text="Suppliers" active={active} />
                <SubMenuItem uri="/supplies" text="Supplies" active={active} />
              </div>
              <NavMenuItem uri="/reports" text="Reports" icon={BarChartIcon} active={active} />
              <NavMenuItem uri="/notifications" text="Notification Center" icon={AnnouncementIcon} active={active} />
            </div>
          </div>
        </div>

        <div className="bot-bx">
          <div className="nav-banner">
            <div className="banner-content">
              <div className="title">
                <ExclamationCircleIcon />

                <h1>Attention!</h1>
              </div>
              <p>In the event of none-use, please log out of the system to ensure data security.</p>
              <span>Click on the Logout button to logout.</span>

              <button type="button" className="logout-btn" onClick={() => logout()}>
                <LogoutIcon />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;
